import React, {Component} from 'react';

import _ from "lodash";

import './styles.scss';
import PyramidChart from "./components/pyramidChart/PyramidChart";
import ColumnChart from "./components/columnChart/ColumnChart";
import LoadingSpinner from "../../../components/spinner/Spinner";
import axios from "axios/index";
import {tokenHeader} from "../../../utils/headers";
import urls from "../../../utils/urls";
import {ajaxHandler} from "../../../utils/errors";
import {connect} from "react-redux";
import Category from "./components/category/Category";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";

class PyramidPerSegment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: 1,
            tableData: false,
            graphData: false,
            xhr: false,
            axiosSource: null,
            data: [{
                name: 'VP Nafta (SLP)',
                color: '#009EB4',
                data: [52, 92]
            }, {
                name: 'VP Diesel (SLP)',
                color: '#89CFDC',
                data: [103, 74]
            }, {
                name: 'Super (SLP)',
                color: '#F49600',
                data: [33, 44]
            }, {
                name: 'FD (SLP)',
                color: '#FBCE07',
                data: [23, 24]
            }]
        }
    }

    componentDidMount(){
        if (this.props.stations.list) {
            if (this.props.categoriesFilter && this.props.categoriesFilter.length>0) {
                this.setState({selectedValue: this.props.categoriesFilter}, () => {
                    this._fetchPyramidData();
                })
            }

            if (this.state.selectedValue) {
                if ((this.props.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (this.props.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (this.props.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this.setState({
                        tableData: false,
                        graphData: false,
                    }, this._fetchData);
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            if (nextProps.categoriesFilter) {
                this.setState({selectedValue: nextProps.categoriesFilter}, () => {
                    this._fetchPyramidData();
                })
            }

            if (this.state.selectedValue) {
                if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this.setState({
                        tableData: false,
                        graphData: false,
                    }, this._fetchData);
                }
            }
        }
    }

    onValueChange = (ev) => {
        this.setState({selectedValue: ev.target.value}, () => {
            this._fetchPyramidData();
        })
    };


    _fetchPyramidData = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let pyramid_graph_url = `${urls.API_ROOT}/api/v1/segment-pyramid/?quarter=${this.state.selectedValue ? this.state.selectedValue.quarter : "Q3"}&year=${this.state.selectedValue ? this.state.selectedValue.year : "2018"}`;
        if (this.props.navigation.selectedArea !== -1) {
            pyramid_graph_url = pyramid_graph_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
        }
        if (this.props.navigation.selectedZone !== -1) {
            pyramid_graph_url = pyramid_graph_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
        }
        if (this.props.navigation.selectedStation !== -1) {
            pyramid_graph_url = pyramid_graph_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }

        axios
            .get(pyramid_graph_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => this.setState({graphData: response.data, xhr: false, axiosSource: null}))
            .catch(ajaxHandler);
    };

    _getActualQuarterData = () => {
        let keys = Object.keys(this.state.graphData.selected_lt).sort().reverse();
        let data = [];
        for (let i in keys) {
            data.push({
                name: this._getCategoryName(keys[i]),
                color: this._getColorByKey(keys[i]),
                data: [this.state.graphData.selected_lt[keys[i]]]
            });
        }

        return data;
    };

    _getColorByKey = (key) => {
        switch (key) {
            case "1. LOW":
                return "#DD1D21";
            case "2. MEDIUM":
                return "#FBCE07";
            case "3. HIGH":
                return "#BED50F";
            case "4. BEST":
                return "#008443";
            default:
                return "#DD1D21";
        }
    };

    _getCategoryName = (category) =>{
        switch (category) {
            case "1. LOW":
                return "Bajo";
            case "2. MEDIUM":
                return "Medio";
            case "3. HIGH":
                return "Alto";
            case "4. BEST":
                return "Top";
        }
    }

    _getColumnsData = () => {
        let data = [];
        let extraData = [];
        let keys = Object.keys(this.state.graphData.selected_st).sort().reverse();
        for (let i in keys) {
            data.push({
                name: this._getCategoryName(keys[i]),
                color: this._getColorByKey(keys[i]),
                data: [this.state.graphData.selected_st[keys[i]]]
            })
        }

        if (this.state.graphData.extra_lt) {
            let keysExtra = Object.keys(this.state.graphData.extra_lt).sort().reverse();
            for (let j in keysExtra) {
                let dataKeyFound = _.find(data, ['name', this._getCategoryName(keysExtra[j])]);
                extraData.push({
                    name: dataKeyFound.name,
                    color: dataKeyFound.color,
                    data: [dataKeyFound.data[0], this.state.graphData.extra_lt[keysExtra[j]]]
                })
            }
        }

        return extraData.length > 0 ? extraData : data;

    };

    render() {
        // const values = this.props.filters;
        const labels = [{name: "Top", description: "Frecuencia semanal tanque lleno", color: "#008443"},
            {name: "Alto", description: "Frecuencia quincenal tanque lleno", color: "#BED50F"},
            {name: "Medio", description: "Frecuencia quincenal medio tanque", color: "#FBCE07"},
            {name: "Bajo", description: "Frecuencia mensual", color: "#DD1D21"}
        ];

        let parent = 'Pais';
        if (this.props.navigation.selectedZone !== -1) {
            parent = 'Zona';
        }
        if (this.props.navigation.selectedStation !== -1) {
            parent = 'Pais';
        }

        return (
            <div className={"container"}>
                {this.state.graphData &&
                <div>
                    {/*<div className={"section-top"}>*/}
                    {/*<Select className={"select graphics-form"} values={values}*/}
                    {/*selectedValue={this.state.selectedValue}*/}
                    {/*onValueChange={this.onValueChange}/>*/}
                    {/*</div>*/}
                    <div className={"subtitle-select"}>
                        <div className={"subtitle"}>Categoría en función a los últimos 6 trimestres</div>
                    </div>

                    <div>
                        <div className={"chart-labels"}>
                            <PyramidChart data={this._getActualQuarterData()}/>
                            <ColumnChart data={this._getColumnsData()} parent={parent}/>
                        </div>
                        <div className={"labels"}>
                            {labels.map(label => {
                                return <Category key={label.name} name={label.name} description={label.description}
                                                 color={label.color}/>
                            })}
                        </div>
                    </div>
                </div>}
                {!this.state.graphData &&
                <VerticalAlign>
                    <LoadingSpinner className={'spinner'} width={50}/>
                </VerticalAlign>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        navigation: state.navigation,
        categoriesFilter: state.categoriesFilter,
        stations:state.stations
    }
};

export default connect(mapStateToProps)(PyramidPerSegment);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/pyramidPerSegment/PyramidPerSegment.js